
















import { Vue, Component } from 'vue-property-decorator'
import { State } from 'vuex-class'
import BytedIconCommentOne from '@byte-design/vue-icons/icons/CommentOne'
import {jumpAthenaLink} from './../const/state/self-service-config'

/*
https://bytedance.feishu.cn/docs/doccndW4nrVvDJv2VwXspbxCshf
https://code.byted.org/ad/adweb_i18n/blob/preonline/djangosite/i18n/locale/country/country.json
*/
@Component({
  name: 'HelpCenter',
  components: {
    BytedIconCommentOne
  }
})
export default class HelpCenter extends Vue {
  @State(state => state.account.accountInfo.country) country: string

  handleClick(): void {
    this.$emit('click')
    jumpAthenaLink(this.country, this)
  }
}
